import './css/App.css';
import DigitalClock from './components/DigitalClock';
import About from './components/About';
import Contact from './components/Contact';
import Skills from './components/Skills';
import { useState } from 'react';
import Inventory from './components/Inventory';
import Projects from './MyProjects/Projects';

function App() {
    const [about, setAbout] = useState(false);
    const [hire, setHire] = useState(false);
    const [skills, setSkills] = useState(false);
    const [inventory, setInventory] = useState(false);
    const [projects, setProjects] = useState(false);
  return (
    <>
    {/* <DigitalClock /> */}
      <div className="container">
      <div className="btn">
          <abbr title='Level is increased based on the skills and experience'><h2>Level: 1</h2></abbr>
          <p>Fresher</p>
      </div>
      <section className="main">
          <nav>
              <ul>
                  <li onClick={()=> setAbout(true)}>About</li>
                  <li onClick={()=> setHire(true)}>Contact</li>
                  <li onClick={()=> setSkills(true)}>Skills</li>
                  <li onClick={()=> setInventory(true)}>Inventory</li>
              </ul>
          </nav>
          <div className="image">
              <img src={require("./images/kindpng_1474000.png")} alt="Sahil's Avatar" id='avatar' />
          </div>
          <div id="options">
              <div className="right-btn">
                  <h3 onClick={()=> setProjects(true)}>Latest Projects</h3>
              </div>
          </div>
      </section>
      <div className="btn">
          <h2>Sahil Ali</h2>
          <p>Frontend Web Developer </p>
      </div>
  </div>

    {about && <About onClose={()=> setAbout(false)} />}
    {hire && <Contact onClose={()=> setHire(false)} />}
    {skills && <Skills onClose={()=> setSkills(false)} />}
    {inventory && <Inventory onClose={()=> setInventory(false)} />}
    {projects && <Projects onClose={()=>setProjects(false)} />}
  

</>
  );
}

export default App;
